import { Typography } from "antd"
import { useState } from "react"
import { buildDescriptionDisplay } from "./lineItemsModel"
import VSpace from "../../common/VSpace"
import RichTextEditor from "../../RichTextEditor/RichTextEditor"
import './LineItemDescription.css'

const { Link } = Typography

type Props = {
  description: string
  descriptionHtml: string | null
}

const LineItemDescription = ({ description, descriptionHtml }: Props) => {
  const [showAll, setShowAll] = useState(false)
  const { title, details } = buildDescriptionDisplay(description, descriptionHtml)

  if (!details) {
    return <span>{title}</span>
  }

  return <VSpace>
    <span>{title}</span>
    {showAll && (details.kind === 'html'
      ? <div className="line-item-rich-description">
        <RichTextEditor value={details.html} disabled removeToolbar />
      </div>
      : <span style={{ whiteSpace: 'pre-wrap' }}>{details.text}</span>)}
    <Link onClick={() => setShowAll(!showAll)}>{showAll ? 'Hide details' : 'See more'}</Link>
  </VSpace>
}

export default LineItemDescription
